export default {
  postSearchQuery () {
    this.searchPosts(this.postSearchQuery)
  },
}
